import React from 'react';
import { motion } from 'framer-motion';
import { WhatsAppIcon } from './Icon';
import { CONTACT } from '../data/site';

const WA_MESSAGE = "Hello Blue Block PMC! I'd like to discuss a project.";

export default function WhatsAppFloat() {
  return (
    <motion.a className="fab fab-wa" href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(WA_MESSAGE)}`}
      target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp"
      initial={{ scale: 0, rotate: -90 }} animate={{ scale: 1, rotate: 0 }} transition={{ delay: 2.2, type: 'spring', stiffness: 220, damping: 14 }}
      whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.92 }}>
      <WhatsAppIcon size={28} />
      <span className="fab-tip">Chat on WhatsApp</span>
    </motion.a>
  );
}
